import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

axios.defaults.withCredentials = true;

const AuthContext = createContext(null);

const API_URL = window.location.origin + '/api';

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      try {
        const response = await axios.get(`${API_URL}/auth/session`);
        setUser(response.data.user || response.data);
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    initAuth();
  }, []);

  const login = async (username, password) => {
    try {
      const response = await axios.post(`${API_URL}/auth/login`, { username, password });
      setUser(response.data.user);
      return { success: true };
    } catch (error) {
      const message = error.response?.data?.detail || 'Giriş başarısız';
      return { success: false, error: message };
    }
  };

  const register = async (username, email, password) => {
    try {
      const response = await axios.post(`${API_URL}/auth/register`, { username, email, password });
      setUser(response.data.user);
      return { success: true };
    } catch (error) {
      const message = error.response?.data?.detail || 'Kayıt başarısız';
      return { success: false, error: message };
    }
  };

  const logout = async () => {
    try { await axios.post(`${API_URL}/auth/logout`); } catch {}
    setUser(null);
  };

  const getAuthHeader = () => ({});

  return (
    <AuthContext.Provider value={{
      user,
      token: null,
      loading,
      login,
      register,
      logout,
      getAuthHeader,
      isAuthenticated: !!user,
      isAdmin: user?.is_admin || false,
      isPremium: user?.is_premium || false
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
